import React, {Component} from 'react';
import styles from "../../InfoCliniche/InfoCliniche.module.css";
import RadioButton from "../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../components/textbox/Input";
import OggettiUtili from "../../../../../utils/OggettiUtili"
import Button from "../../../../../components/button/Button";
import Utils from "../../../../../utils/Utils";
import {withTranslation} from "react-i18next";
import Select from "../../../../../components/select/Select"
import SelectAutocomplete from "../../../../../components/selectAutocomplete/SelectAutocomplete";
import SessioneUtente from "../../../../../sessionManager/SessioneUtente";
import Ruoli from "../../../../../utils/Ruoli";
import $ from "jquery";
import Icon from "../../../../../components/icon/Icon";


class CollettivitaPreMalattia extends Component {


    state = {
        collettivitaPreMalattia: {
            collettivitaFrequentata: this.props.malattiePremal.includes(this.props.segnalazioneCopia.malattia)? "SI*" : "",
            collettivita: [{
                collettivita: this.props.malattiePremal.includes(this.props.segnalazioneCopia.malattia)? "16*" : "",
                numeroPersoneSuscettibili: "",
                informazioniAggiuntive: ""
            }],
            scuola: "",
            classe: "",
            sezione: "",
            corretto: ["Campo \"Collettività frequentata\" mancante"]
        },
        clickCollettivitaPre: 0,
        boxesCollettivitaPre: []
    }

    constructor(props) {
        super(props);
        this.aggiungiCollettivitaPre = this.aggiungiCollettivitaPre.bind(this)
        this.setCollettivitaFrequentata = this.setCollettivitaFrequentata.bind(this)
        this.riceviValore = this.riceviValore.bind(this)
        this.setValoriCollettivita = this.setValoriCollettivita.bind(this)
        this.setValoriInfoAggiuntive = this.setValoriInfoAggiuntive.bind(this)
        this.setValoriNumeroPersoneSuscettibili = this.setValoriNumeroPersoneSuscettibili.bind(this)
        this.aggiungiCollettivitaPreAlloStato = this.aggiungiCollettivitaPreAlloStato.bind(this)
        this.setScuola = this.setScuola.bind(this)
        this.creazioneJsonBackend = this.creazioneJsonBackend.bind(this)
        this.validate = this.validate.bind(this)
        this.uniqueObjectCollettivitaPre = this.uniqueObjectCollettivitaPre.bind(this)
        this.disabledSelectAutocomplete = this.disabledSelectAutocomplete.bind(this)
        this.eliminaRow = this.eliminaRow.bind(this)
    }

    componentDidMount() {
        this.setCollettivitaFrequentata("SI*");
        if (this.props.segnalazioneCopia.datiSpecifici && this.props.segnalazioneCopia.datiSpecifici.collettivitaPreMalattia) {
            let propsCollettivitaPreMalattia = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.datiSpecifici.collettivitaPreMalattia));
            let collettivitaPreMalattia = this.state.collettivitaPreMalattia
            collettivitaPreMalattia.collettivitaFrequentata = propsCollettivitaPreMalattia.collettivitaFrequentata ? propsCollettivitaPreMalattia.collettivitaFrequentata : ""
            collettivitaPreMalattia.scuola = propsCollettivitaPreMalattia.scuola ? propsCollettivitaPreMalattia.scuola : ""
            collettivitaPreMalattia.classe = propsCollettivitaPreMalattia.classe ? propsCollettivitaPreMalattia.classe : ""
            collettivitaPreMalattia.sezione = propsCollettivitaPreMalattia.sezione ? propsCollettivitaPreMalattia.sezione : ""
            collettivitaPreMalattia.collettivita = propsCollettivitaPreMalattia.collettivita ? propsCollettivitaPreMalattia.collettivita : this.state.collettivitaPreMalattia.collettivita
            if (!collettivitaPreMalattia.collettivitaFrequentata) {
                collettivitaPreMalattia.corretto = ["Campo \"Collettività frequentata\" mancante"]
            } else
                collettivitaPreMalattia.corretto = []
            this.setState({collettivitaPreMalattia: collettivitaPreMalattia})
            let click = 0
            if (collettivitaPreMalattia.collettivita) {
                for (let i = 0; i < collettivitaPreMalattia.collettivita.length; i++) {
                    click++
                    this.aggiungiCollettivitaPre(click)
                }
            } else {
                click++
                this.aggiungiCollettivitaPre()
            }
            this.props.setCollettivitaPreMalattia(this.state.collettivitaPreMalattia, this)
        } else {
            this.aggiungiCollettivitaPre()
            this.props.setCollettivitaPreMalattia(this.state.collettivitaPreMalattia, this)
        }

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.clickCollettivitaPre > this.state.clickCollettivitaPre) {
            this.aggiungiCollettivitaPre()
            let collettivitaPreMalattiaPerBE = this.creazioneJsonBackend()
            this.props.setCollettivitaPreMalattia(this.state.collettivitaPreMalattia, this, collettivitaPreMalattiaPerBE)
        }
        if (prevState !== this.state) {
            let collettivitaPreMalattiaPerBE = this.creazioneJsonBackend()
            this.props.setCollettivitaPreMalattia(this.state.collettivitaPreMalattia, this, collettivitaPreMalattiaPerBE)
        }
    }

    uniqueObjectCollettivitaPre(elPre) {
        const tmpcollettivitaPreMalattia = new Map()
        let collettivitaInMalattia = JSON.parse(JSON.stringify(this.state.collettivitaPreMalattia))

        const rscollettivitaPreMalattia = elPre.reduce((acc, e) => {
            if (tmpcollettivitaPreMalattia.has(e.collettivita) && tmpcollettivitaPreMalattia.has(e.numeroPersoneSuscettibili) && tmpcollettivitaPreMalattia.has(e.informazioniAggiuntive)) {
                if (!tmpcollettivitaPreMalattia.get(e.collettivita).includes(e.jobid) && !tmpcollettivitaPreMalattia.get(e.numeroPersoneSuscettibili).includes(e.jobid) && !tmpcollettivitaPreMalattia.get(e.informazioniAggiuntive).includes(e.jobid)) {
                    acc.push(e)
                    tmpcollettivitaPreMalattia.set(e.collettivita, [...tmpcollettivitaPreMalattia.get(e.collettivita), e.jobid])
                    tmpcollettivitaPreMalattia.set(e.numeroPersoneSuscettibili, [...tmpcollettivitaPreMalattia.get(e.numeroPersoneSuscettibili), e.jobid])
                    tmpcollettivitaPreMalattia.set(e.informazioniAggiuntive, [...tmpcollettivitaPreMalattia.get(e.informazioniAggiuntive), e.jobid])
                }
            } else {
                acc.push(e)
                tmpcollettivitaPreMalattia.set(e.collettivita, [e.jobid])
                tmpcollettivitaPreMalattia.set(e.numeroPersoneSuscettibili, [e.jobid])
                tmpcollettivitaPreMalattia.set(e.informazioniAggiuntive, [e.jobid])
            }
            return acc
        }, [])

        collettivitaInMalattia.collettivita = rscollettivitaPreMalattia
        return collettivitaInMalattia
    }

    validate() {
        if (this.state.collettivitaPreMalattia.collettivita) {
            for (let i = 0; i < this.state.collettivitaPreMalattia.collettivita.length; i++) {
                if (this.state.collettivitaPreMalattia.collettivitaFrequentata === "NO" && this.state.collettivitaPreMalattia.collettivita[i].collettivita) {
                    return (
                        this.props.aggiungiToaster(
                            ["Messages.ERR_01_01_0F_AHPRE"]), 1
                    )
                } else if (this.state.collettivitaPreMalattia.collettivitaFrequentata === "NO" && this.state.collettivitaPreMalattia.collettivita[i].numeroPersoneSuscettibili) {
                    return (
                        this.props.aggiungiToaster(
                            ["Messages.ERR_01_01_0F_AIPRE"]), 1
                    )
                } else if (this.state.collettivitaPreMalattia.collettivitaFrequentata === "NO" && this.state.collettivitaPreMalattia.collettivita[i].informazioniAggiuntive) {
                    return (
                        this.props.aggiungiToaster(
                            ["Messages.ERR_01_01_0F_ALPRE"]), 1
                    )
                }
            }
            let ckeckScuola = false;
            if (this.state.collettivitaPreMalattia.collettivita) {
                for (let i = 0; i < this.state.collettivitaPreMalattia.collettivita.length; i++) {
                    if (this.state.collettivitaPreMalattia.collettivita[i].collettivita && this.state.collettivitaPreMalattia.collettivita[i].collettivita === "18") {
                        ckeckScuola = true;
                        break;
                    }
                }
            }
            if (this.state.collettivitaPreMalattia.collettivitaFrequentata === "NO" && this.state.collettivitaPreMalattia.scuola) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_AMPRE"]), 1
                )
            } else if (!ckeckScuola && this.state.collettivitaPreMalattia.scuola) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_ANPRE"]), 1
                )
            } else if (this.state.collettivitaPreMalattia.collettivitaFrequentata === "NO" && this.state.collettivitaPreMalattia.classe) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_AOPRE"]), 1
                )
            } else if (!ckeckScuola && this.state.collettivitaPreMalattia.classe) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_APPRE"]), 1
                )
            } else if (this.state.collettivitaPreMalattia.collettivitaFrequentata === "NO" && this.state.collettivitaPreMalattia.sezione) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_AQPRE"]), 1
                )
            } else if (!ckeckScuola && this.state.collettivitaPreMalattia.sezione) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_ARPRE"]), 1
                )
            }

        }


        let collettivita = JSON.parse(JSON.stringify(this.state.collettivitaPreMalattia.collettivita))
        let arrayCollettivitaPulito = Utils.removeEmptyValueFromObject(collettivita)
        let arrayNuovo = Utils.eliminaNullArray(arrayCollettivitaPulito)

        let objFinal = this.creazioneJsonBackend(this.uniqueObjectCollettivitaPre(arrayNuovo))
        this.props.setCollettivitaPreMalattia(this.state.collettivitaPreMalattia, this, objFinal);

    }

    creazioneJsonBackend(collettivitaPreMalattia) {


        let collettivita = JSON.parse(JSON.stringify(collettivitaPreMalattia ? collettivitaPreMalattia : this.state.collettivitaPreMalattia))
        let collettivitaPreMalattiaPerBE = Utils.removeFieldFromObject(collettivita, "corretto")
        let arrayCollettivita = collettivita.collettivita ? collettivita.collettivita : []
        let arrayCollettivitaPulito = Utils.removeEmptyValueFromObject(arrayCollettivita)
        let arrayNuovo = Utils.eliminaNullArray(arrayCollettivitaPulito)
        collettivitaPreMalattiaPerBE["collettivita"] = arrayNuovo
        return Utils.removeEmptyValueFromObject(collettivitaPreMalattiaPerBE)
    }

    disabledSelectAutocomplete() {
        let condizione = this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
            this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)
        Utils.disabledSelectAutocomplete(condizione)
    }

    riceviValore(field, event) {
        let collettivitaPreMalattia = this.state.collettivitaPreMalattia;
        if (field == "classe") {
            collettivitaPreMalattia.classe = event.target.value;
        } else if (field == "sezione") {
            collettivitaPreMalattia.sezione = event.target.value;
        }
        this.setState({collettivitaPreMalattia: collettivitaPreMalattia});
    }

    setScuola(event) {
        let collettivita = this.state.collettivitaPreMalattia
        collettivita.scuola = event.target.value
        this.setState({collettivitaPreMalattia: collettivita});
    }

    setCollettivitaFrequentata(value) {
        let collettivita = this.state.collettivitaPreMalattia
        collettivita.collettivitaFrequentata = value
        collettivita.corretto = []
        this.setState({collettivitaPreMalattia: collettivita});
    }

    setValoriCollettivita(event) {
        let click = this.state.clickCollettivitaPre - 1
        let collettivitaPreMalattia = this.state.collettivitaPreMalattia
        collettivitaPreMalattia.collettivita[event.target.id].collettivita = event.target.value
        this.setState({collettivitaPreMalattia: collettivitaPreMalattia, clickCollettivitaPre: click})
        $(function () {
            $('.selectpicker').selectpicker('refresh');
        });
    }

    setValoriNumeroPersoneSuscettibili(field, event) {
        let click = this.state.clickCollettivitaPre - 1
        let id = parseInt(field.replace("numeroPersoneSuscettibili", ""))
        let collettivitaPreMalattia = this.state.collettivitaPreMalattia
        collettivitaPreMalattia.collettivita[id].numeroPersoneSuscettibili = event.target.value
        this.setState({collettivitaPreMalattia: collettivitaPreMalattia, clickCollettivitaPre: click})
    }

    setValoriInfoAggiuntive(field, event) {
        let click = this.state.clickCollettivitaPre - 1
        let id = parseInt(field.replace("informazioniAggiuntive", ""))
        let collettivitaPreMalattia = this.state.collettivitaPreMalattia
        collettivitaPreMalattia.collettivita[id].informazioniAggiuntive = event.target.value
        this.setState({collettivitaPreMalattia: collettivitaPreMalattia, clickCollettivitaPre: click})
    }

    aggiungiCollettivitaPreAlloStato() {
        let collettvita = {
            collettivita: "",
            numeroPersoneSuscettibili: "",
            informazioniAggiuntive: ""
        }
        let collettivitaTotali = this.state.collettivitaPreMalattia
        collettivitaTotali.collettivita.push(collettvita)
        this.setState({collettivitaPreMalattia: collettivitaTotali})
    }

    eliminaRow(i){
        let collettivitaPreMalattia = this.state.collettivitaPreMalattia;
        let boxesCollettivitaPre = this.state.boxesCollettivitaPre
        let clickCollettivitaPre = this.state.clickCollettivitaPre
        collettivitaPreMalattia.collettivita.splice(i,1)
        boxesCollettivitaPre.splice(i,1)
        this.setState({boxesCollettivitaPre: boxesCollettivitaPre, collettivitaPreMalattia: collettivitaPreMalattia});
        if(i===1) clickCollettivitaPre = clickCollettivitaPre - 1
        else clickCollettivitaPre = clickCollettivitaPre - 2
        this.aggiungiCollettivitaPre(clickCollettivitaPre)
        $(document).ready(function () {
            $('.selectpicker').selectpicker('refresh')
        });
    }

    aggiungiCollettivitaPre(clickInModifica) {

        let click = clickInModifica ? clickInModifica : this.state.clickCollettivitaPre === this.state.collettivitaPreMalattia.collettivita.length ? this.state.clickCollettivitaPre : this.state.clickCollettivitaPre + 1
        let boxCollettivitaPre = [];
        let collettivita = Utils.mapToArray(OggettiUtili.Collettivita)
        if (this.props.malattia === "0578") {
            collettivita.pop()
            collettivita.push(
                {
                    "codice": "19",
                    "descrizione": "STRUTTURE SPORTIVE/PALESTRE"},
                {
                    "codice": "20",
                    "descrizione": "SAUNA"},
                {
                    "codice": "21",
                    "descrizione": "MASSAGGI"
                })
        }
        for (let i = 0; i < click; i++) {
            boxCollettivitaPre.push(
                <div>
                    <div className={"row"}>
                        <div className={`col-lg-6 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p className={styles.testo}>{this.props.t("DatiSpecifici.CollettivitaPreMalattia.collettivita")}</p>
                            <SelectAutocomplete
                                value={this.state.collettivitaPreMalattia.collettivita[i].collettivita === "16*"? "16" : this.state.collettivitaPreMalattia.collettivita[i].collettivita}
                                field={i}
                                id={i}
                                disabled={this.props.segnalazioneCopia.migrazione || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneCopia && (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice))}
                                onChange={this.setValoriCollettivita}
                                style={{width: "100%"}}
                                functionMap={collettivita.sort(Utils.SorterObjectDesc).map((oggetto) => {
                                    return (<option value={oggetto.codice} style={{backgroundColor:'white'}}>{oggetto.descrizione}</option>)
                                })}
                                
                                addclass={!this.props.segnalazioneCopia.stepConfermati.datiSpecificiConfermati && this.props.malattiePremal.includes(this.props.segnalazioneCopia.malattia) && this.state.collettivitaPreMalattia.collettivita[i].collettivita === "16*"? 'select-yellow' : !this.props.segnalazioneCopia.stepConfermati.datiSpecificiConfermati? 'select-white' : ''}
                            >
                            </SelectAutocomplete>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <div>
                                <p className={styles.testo}>
                                    {this.props.t("DatiSpecifici.CollettivitaPreMalattia.persone")}
                                </p>
                                <Input
                                    id={"idNumeroPersoneSuscettibili" + (i)}
                                    type="number"
                                    min="0"
                                    onChange={this.setValoriNumeroPersoneSuscettibili}
                                    field={"numeroPersoneSuscettibili" + (i)}
                                    errorMessage={"Numero Persone Suscettibili non valido"}
                                    value={this.state.collettivitaPreMalattia.collettivita[i].numeroPersoneSuscettibili}
                                    placeholder={"Numero Persone Suscettibili"}
                                />
                            </div>
                        </div>
                        <div className={"col-lg-3"}>
                            {
                                i>0 && !(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice))?
                                    <span id={"elimina"+i}
                                          onClick={()=>
                                              this.eliminaRow(i)

                                          }
                                    ><Icon id={"it-delete"} style={{fill: "red",float: "right", marginTop: "2.2rem", cursor: "pointer"}} /></span>
                                    : <></>
                            }

                        </div>
                    </div>
                    <div>
                        <p className={styles.testo}>{this.props.t("DatiSpecifici.CollettivitaPreMalattia.informazioni")}</p>
                        <Input type={"textarea"}
                               placeholder="campo a testo libero"
                               onChange={this.setValoriInfoAggiuntive}
                               value={this.state.collettivitaPreMalattia.collettivita[i].informazioniAggiuntive}
                               id={"informazioniAggiuntive" + (i)}
                               field={"informazioniAggiuntive" + (i)}
                               errorMessage={"Campo informazioni aggiuntive non valido"}
                        />
                        {i < 1 ? <Button
                            classes="btn btnBluOutline "
                            onClick={() => {
                                this.aggiungiCollettivitaPreAlloStato();
                                this.aggiungiCollettivitaPre()
                            }}
                            style={{
                                border: "none",
                                background: "none",
                                fontSize: "16px",
                                color: "#1b7ea9",
                                textDecoration: "underline"
                            }}
                            text={this.props.t("DatiSpecifici.CollettivitaPreMalattia.aggiungi")}
                        /> : <div/>}
                    </div>
                </div>
            )
        }
        this.setState({clickCollettivitaPre: click, boxesCollettivitaPre: boxCollettivitaPre});
    }

    render() {
        console.log("listaColl: " + JSON.stringify(Object.values(this.state.collettivitaPreMalattia)))
        return (
            <div style={{marginTop: "1rem"}}>
                <h6>{this.props.t("DatiSpecifici.CollettivitaPreMalattia.titolo")}</h6>
                <hr className={styles.hr}/>
                <div className={"container"}>
                    <div className={"row"}>
                        <div>
                            <p className={styles.testo} style={{marginLeft: "8px", marginTop: "10px"}}>
                                {this.props.t("DatiSpecifici.CollettivitaPreMalattia.collettivitaFrequentata")}
                            </p><span className={styles.mandatoryColor}>*</span>
                        </div>
                        <div style={{marginLeft: "10px"}}>
                            <RadioButton id={"collettivitapresi"} name={"collettivitapre"} label={"SI"}
                                         onClick={this.setCollettivitaFrequentata}
                                         smallLabel={true}
                                         value={"SI"}
                                         checked={this.state.collettivitaPreMalattia.collettivitaFrequentata === "SI" || this.state.collettivitaPreMalattia.collettivitaFrequentata === "SI*"}
                                         isYellow={!this.props.segnalazioneCopia.stepConfermati.datiSpecificiConfermati && this.props.malattiePremal.includes(this.props.segnalazioneCopia.malattia) && this.state.collettivitaPreMalattia.collettivitaFrequentata === "SI*"}
                                         border={!this.props.segnalazioneCopia.stepConfermati.datiSpecificiConfermati}>

                            </RadioButton>
                        </div>
                        <div style={{marginLeft: "10px"}}>
                            <RadioButton id={"collettivitapreno"} name={"collettivitapre"} label={"NO"}
                                         onClick={this.setCollettivitaFrequentata}
                                         smallLabel={true}
                                         value={"NO"}
                                         checked={this.state.collettivitaPreMalattia.collettivitaFrequentata === "NO"}
                                         border={!this.props.segnalazioneCopia.stepConfermati.datiSpecificiConfermati}>
                            </RadioButton>
                        </div>
                    </div>

                    {this.state.boxesCollettivitaPre}


                    <div className={"row"} style={{marginTop: "1rem"}}>
                        <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <p className={styles.testo}>{this.props.t("DatiSpecifici.CollettivitaPreMalattia.scuola")}</p>
                            <Select
                                value={this.state.collettivitaPreMalattia.scuola}
                                onChange={this.setScuola}
                                style={{width: "100%"}}
                                functionMap={Utils.mapToArray(OggettiUtili.Scuole).map((oggetto) => {
                                    return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                })}
                            >
                            </Select>
                        </div>
                        <div className={`col-lg-2 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <div>
                                <p className={styles.testo}>
                                    {this.props.t("DatiSpecifici.CollettivitaPreMalattia.sezione")}
                                </p>
                                <Input
                                    id={"sezione"}
                                    onChange={this.riceviValore}
                                    field={"sezione"}
                                    errorMessage={"sezione non valido"}
                                    value={this.state.collettivitaPreMalattia.sezione}
                                    placeholder={"sezione"}
                                />
                            </div>
                        </div>
                        <div className={`col-lg-2 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <div>
                                <p className={styles.testo}>
                                    {this.props.t("DatiSpecifici.CollettivitaPreMalattia.classe")}
                                </p>
                                <Input
                                    id={"classe"}
                                    onChange={this.riceviValore}
                                    field={"classe"}
                                    errorMessage={"classe non valido"}
                                    value={this.state.collettivitaPreMalattia.classe}
                                    placeholder={"classe"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

export default withTranslation('common')(CollettivitaPreMalattia)
